import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { DocumentsComponent } from './documents.component';
import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EditDocumentDialogModule } from './edit-document-dialog.module';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        EditDocumentDialogModule,
        MatButtonModule,
        MatIconModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        DocumentsComponent,
    ],
    exports: [
        DocumentsComponent
    ]
})
export class DocumentsModule { }


